import axios from "axios";
import { ROOT_SERVER } from "../utilities/Static";
import { normalizeLoginResponse } from "./loginAccount";

export default async function LoginFunction(identifier, password = "") {
  const payload = {
    email: identifier,
    identifier,
  };

  if (password) {
    payload.password = password;
  }

  const { data: response } = await axios.post(`${ROOT_SERVER}login`, payload);
  return normalizeLoginResponse(response) || response;
}
